import LeftArrowDark from "assets/images/arrowLeftCircle.svg";
import RightArrowDark from "assets/images/arrowRightCircle.svg";
import LeftArrowLight from "assets/images/arrowLeftLightTheme.svg";
import RightArrowLight from "assets/images/arrowRightLightTheme.svg";

export const darkTheme = {
  name: "dark-theme",
  breakpoints: {
    mobile: "600px",
    tablet: "900px",
    laptop: "1200px",
    desktop: "1536px",
  },
  colors: {
    white: "#ffffff",
    light: '#5C0D99',
    medium: '#66397e',
    dark: '#460073',
    searchinputbg: "#460073",
    sidebarcolor: '#A100FF',
    sidebaropen: "#A100FF",
    sidebaricons: "#ffffff",
    buttonchipcolor: "rgba(85, 85, 85, .4)",

    lightGrey: "#555555",
    lightGreyRgba: "rgba(85, 85, 85, .4)",
    mediumGrey: "#191919",
    darkGrey: "#1d1d1d",

    highlight1: '#7dcdb6', 
    highlight2: '#ce93d8', 
    highlight3: '#f1628c', 
    highlight4: '#f470a2', 
    highlight5: '#6d9faf',
    highlight6: '#90caf9',

    textColor: "#f5edf5",
    textColorOpposite: "#232325",
    textColorAccent: "#ffffff",
    
    fatal_criticality: '#FE8CFB',
    critical_criticality: '#F35C88',
    high_criticality: '#edae6a',
    medium_criticality: '#F89C03',
    low_criticality: '#FFC802',
    informative_criticality: '#4BA7AE',
    unclassified_criticality: '#39D8A1',

    open_incident: '#F35C88',
    in_progress_incident: '#FFC802',
    closed_incident: '#39D8A1',
    requested_incident: '#4BA7AE',

    // Tags
    tagBtnBg: "#e08ad0", 

    // Tables
    tableBackground: "#212121",
    
    // Updated button colors for light theme
    buttonText: '#8e8e93',
    buttonBorder: '#3C3F43',
    buttonBorderHighlight: '#34C2FF',
    buttonBackground: '#1A1D23',
    buttonHover: "#222",

    // Login colors - keeping your purples
    loginCardBackground: "#66397e",
    loginBackgroundIdle: "#8A1C9E",
    loginBackgroundHover: "#9C3DB0",
    loginBackgroundActive: "#75247F",

    // Search Bar
    searchbg: "rgba(255, 255, 255, 0.1)",
    
    // Updated history/chat colors
    historyBg: "#212121",
    historyItemselect: "#464646",
    historyItemhvr: "#464646",
    userInputbg:"#1C2128",
    fullhistoryitemsbg: "rgba(24, 28, 35, 0.95)",
    uncheckedColor: "#2B313A",
    rightpreview:"#1C2128",

    // Updated Dashboard Colors
    dashboardHighlightBg: "#5C0D99",
    dashboardCardBg: '#A100FF',
    dashboardSelectedCardsBg: '#525875',
    barChartBarBg: '#5C0D99',
    barChartBarBgHv: '#7dcdb6',
    barChartBarFullWBgHv: 'rgba(170, 30, 250, 0.2)',

    background: "#000000",
    textDisabledColor: "#96968C",
    footerColor: "#00ffff",
    
    divider: '#76766B',

    sliderTextColor: "#d3d3d3",
    sliderDotColor: "#FFFFFF",

    darkBlueBtn: "#273746",
    errortextColor: "#F2F2F2",
    tabTextColor: "#E6E6DC",
    actionButtonColor: "rgb(59 130 246 / 0.2)",
    actionButtonColorHvr: "#34c3ff",

    activeToggleColor: "#05f0a5",
    warningColor: "#f1628c",
    iconColor: "#ffffff",
    toastColor: "#232325",

    actionPopupBackgroundColor: "#F0F4FA",

    lightButton: "#A100FF",
    selectGrey: "#3A414F",
    selectText: "#8B92A0",
    sidebarLightHover: "#7500C0"
  },
  severity: {
    range: [
      "#6d9faf", "#77b4ab", "#d2edde", "#f2cd47", "#e6a639",
      "#d2ad40", "#f2cd47", "#edae6a", "#e98f8d", "#dc7a9a"
    ]
  },
  font: {
    small: "12px",
    medium: "0.9em",
    large: "1em",
    xl: "1.25em",
    xxl: "2em",
    h1: "3rem",
    h2: "2rem",
    h3: "1rem",
    h4: "0.875rem"
  },
  borders: {
    borderColor: "rgba(0,0,0,.125)",
    headerBorder: "1px solid rgba(0, 0, 0, 0.25)",
    modalBorder: "1px solid rgba(0, 0, 0, 0.15)",
    customButton: "1px solid rgba(0, 0, 0, 0.50)",
    borderRadius: "5px",
    inputBoxBorder: "1px solid rgba(102, 57, 126, 1)"
  },
  images: {
    leftArrow: LeftArrowDark,
    rightArrow: RightArrowDark,
  },
  shadows: {
    button: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
    boxShadowInset: "inset 1px 1px 4.2px hsl(0deg 0% 0% / 0.3))",
    boxShadowMini: "0.5px 0.5px 4.2px hsl(0deg 0% 0% / 0.17)",
    boxShadow: "2px 2px 4.2px hsl(0deg 0% 0% / 0.17)",
    filter: "drop-shadow(4px 8px 64px hsla(291deg, 50%, 19%, 0.5))"
  }
};

export const lightTheme = {
  name: "light-theme",
  breakpoints: {
    mobile: "600px",
    tablet: "900px",
    laptop: "1200px",
    desktop: "1536px",
  },
  colors: {
    white: "#ffffff",
    light:'#A100FF',
    medium: 'rgb(229, 209, 255)',
    dark: '#ffffff',
    
    searchinputbg: "#E5E7EB",
    sidebarcolor: "#A100FF",
    sidebaropen: "#A100FF",
    sidebaricons: "#ffffff",
    buttonchipcolor: "#F2F2F2",

    lightGrey: "#999999",
    lightGreyRgba: "#E6DCFF",
    mediumGrey: "#555555",
    darkGrey: "#111111",

    // Keeping your highlight colors
    highlight1: "#7dcdb6",
    highlight2: "#AF24FF",
    highlight3: "#f1628c",
    highlight4: "#f470a2",
    highlight5: "#6d9faf",
    highlight6: '#1976d2',
    
    textColor: "#2B2733",
    textColorOpposite: "#f5edf5",
    textColorAccent: "#111D5E",
    
    // Keeping your criticality and incident colors as they're likely following standards
    fatal_criticality: '#FE8CFB',
    critical_criticality: '#F35C88',
    high_criticality: '#edae6a',
    medium_criticality: '#F89C03',
    low_criticality: '#FFC802',
    informative_criticality: '#4BA7AE',
    unclassified_criticality: '#39D8A1',
    
    open_incident: '#F35C88',
    in_progress_incident: '#FFC802',
    closed_incident: '#39D8A1',
    requested_incident: '#4BA7AE',

    // Tags
    tagBtnBg: "rgb(229, 209, 255)",

    // Tables
    tableBackground: "#ffffff",
    
    // Updated button colors for light theme
    buttonText: '#232325',  
    buttonBorder: '#e0e0e5',
    buttonBorderHighlight: '#aa1efa',
    buttonBackground: '#A100FF',
    buttonHover: "#f5f0ff",
    
    // Login colors - keeping your purples
    loginCardBackground: "#ffffff",
    loginBackgroundIdle: "#aa1efa",
    loginBackgroundHover: "#b83dfb",
    loginBackgroundActive: "#9517e1",
    
    // Updated history/chat colors
    historyBg: "white",
    historyItemselect: "rgb(229, 209, 255)",
    historyItemhvr: "rgb(229, 209, 255)",
    userinputbg:"white",
    fullhistoryitemsbg: "white",
    uncheckedColor: "white",
    rightpreview:"white",
    

    // Search Bar
    searchbg: "transparent",

    // Updated Dashboard Colors
    dashboardHighlightBg: "#8884d8",
    dashboardCardBg: '#FAFAFA',
    dashboardSelectedCardsBg: '#A100FF',
    barChartBarBg: '#aa1efa',
    barChartBarBgHv: '#AF24FF',
    barChartBarFullWBgHv: '#ce93d8',
    
    divider: '#e0e0e5',
    
    background: "#ffffff",
    textDisabledColor: "#a1a1a6",
    footerColor: "#aa1efa",
    
    sliderTextColor: "#232325",
    sliderDotColor: "#FFFFFF",
    
    darkBlueBtn: "#aa1efa",
    errortextColor: "#ff3b30",
    tabTextColor: "#232325",
    actionButtonColor: "rgb(59 130 246 / 0.5)",
    actionButtonColorHvr: "#34c3ff",
    

    activeToggleColor: "#34c759",
    warningColor: "#ff9500",
    iconColor: "#232325",
    toastColor: "#ffffff",
    
    actionPopupBackgroundColor: "#ffffff",
    lightButton: "#A100FF",
    selectGrey: "#3A414F",
    selectText: "#8B92A0",
    sidebarLightHover: "#7500C0"

  },
  severity: {
    range: [
      "#80ffff", "#8beeff", "#8beeff", "#8beeff", "#acb8ff",
      "#cc9dff", "#eb7ee7", "#fc60b6", "#fe497f", "#ee4646"
    ]
  },
  font: {
    small: "12px",
    medium: "0.9em",
    large: "1em",
    xl: "1.25em",
    xxl: "2em",
    h1: "3rem",
    h2: "2rem",
    h3: "1rem",
    h4: "0.875rem"
  },
  borders: {
    borderColor: '#241f2d',
    headerBorder: "1px solid rgba(0, 0, 0, 0.25)",
    modalBorder: "1px solid rgba(0, 0, 0, 0.15)",
    customButton: "1px solid rgb(51 65 85 / var(--tw-border-opacity))",
    borderRadius: "5px",
    inputBoxBorder: "1px solid rgba(102, 57, 126, 1)"
  },
  images: {
    leftArrow: LeftArrowLight,
    rightArrow: RightArrowLight,
  },
  shadows: {
    button: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
    boxShadowInset: "inset 1px 0.5px 2.2px hsl(0deg 0% 0% / 0.3)",
    boxShadow: "2px 2px 4.2px hsl(0deg 0% 0% / 0.17)",
    boxShadowMini: "0.5px 0.5px 4.2px hsl(0deg 0% 0% / 0.17)",
    filter: "drop-shadow(4px 8px 64px hsla(291deg, 50%, 19%, 0.5))"
  }
};
